<template>
  <section class="quick-words">
    <div class="c-container">
      <AppTextBlock
        class="quick-words__content"
        v-if="data.text !== undefined"
        :data="{ title: data.title, content: data.text }"
      />
    </div>
  </section>
</template>

<script>
import AppTextBlock from '@/components/AppTextBlock.vue';

export default {
  name: 'QuickWords',

  components: {
    AppTextBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/variables';

.quick-words .quick-words__content {
  position: relative;
  width: 100%;
}

.quick-words .quick-words__content::v-deep {
  & > p {
    @include mq(ipadP) {
      max-width: 960px;
      margin-left: 40px;
    }

    @include mq(dm) {
      max-width: 1280px;
    }

    @include mq(dl) {
      max-width: 1440px;
    }

    @include mq(dxl) {
      max-width: 1680px;
    }
  }
}
</style>
